import React from 'react';

import useIntersectionObserver from '../../../hooks/useIntersectionObserver';

import {IHotelData, IHotelDataType} from '../redux/types';

import SmartEngageBanner from './SmartEngageBanner';

import SrpCardAllComponent from '../../../../stories/components/hotels/Loadingpage/SrpCard/SrpCardAllComponent/SrpCardAllComponent';
import BannerCard from '../../../../stories/components/hotels/SRP/BannerCard/BannerCard';

const options = {
  root: null,
  threshHold: 0.01,
};

const HotelListPlaceholder = ({
  shouldFetchMore,
  fetchMoreFn,
  showLastItemLoader,
  data,
  children,
  error
}: {
  shouldFetchMore: boolean;
  fetchMoreFn: any;
  showLastItemLoader: boolean;
  data: IHotelData & {type: IHotelDataType, selector:number};
  children: Element;
  error: boolean;
}) => {
  let elRef = null;

  if (shouldFetchMore) {
    const [watcherRef] = useIntersectionObserver(options, () => {
      fetchMoreFn(true);
    });
    elRef = watcherRef;
  }

  const itemToRender = () => {
    const arr = [];
    if (data.type === 'SmartEngageBanner') arr.push(<SmartEngageBanner selector={data.selector} page="SRP" />);
    arr.push(children);
    if (showLastItemLoader) arr.push(<SrpCardAllComponent />);
    if (error) arr.push(<BannerCard text="Failed to fetch hotels. Please try reloading or resetting filters" />);
    return arr;
  };

  return <div ref={elRef}>{itemToRender()}</div>;
};

export default HotelListPlaceholder;
